

































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SuporteHospitalSlaStore, { HospitalSlaConfigProps,
  HospitalSlaModalProps,
  HospitalSlaProps } from '../Store/SuporteHospitalSlaStore'

@Component
export default class ComponentModalSuporteEditarHospitalSla extends Vue {
  saveLoading: boolean = false

  get solicitacaoSituacoes() {
    return this.getSuporteHospitalSlaStore.solicitacaoSituacoes
  }

  get getSuporteHospitalSlaStore() {
    return getModule(SuporteHospitalSlaStore, this.$store)
  }

  get modal() {
    return this.getSuporteHospitalSlaStore.modal
  }

  set modal(value: { isOpen: boolean; target: HospitalSlaModalProps }) {
    this.getSuporteHospitalSlaStore.setModal(value)
  }

  get modalTitle() {
    const titles = {
      EDIT_SLA: 'Editar SLA',
      EDIT_SLA_CONFIG: 'Editar configuração SLA',
      DELETE: 'Excluir item',
      REGISTER_SLA: 'Cadastrar SLA',
      REGISTER_SLA_CONFIG: 'Cadastrar configuração SLA',
    }
    return titles[this.modal.target]
  }

  get buttonIcon() {
    const icons = {
      EDIT_SLA: 'edit',
      EDIT_SLA_CONFIG: 'edit',
      DELETE: 'delete',
      REGISTER_SLA: 'save',
      REGISTER_SLA_CONFIG: 'save',
    }
    return icons[this.modal.target]
  }

  get newHospitalSlaConfig() {
    return this.getSuporteHospitalSlaStore.newHospitalSlaConfig
  }

  set newHospitalSlaConfig(value: HospitalSlaConfigProps) {
    this.getSuporteHospitalSlaStore.setNewHospitalSlaConfig(value)
  }

  get newHospitalSla() {
    return this.getSuporteHospitalSlaStore.newHospitalSla
  }

  set newHospitalSla(value: HospitalSlaProps) {
    this.getSuporteHospitalSlaStore.setNewHospitalSla(value)
  }

  get isSlaConfig() {
    return ['EDIT_SLA_CONFIG', 'REGISTER_SLA_CONFIG'].includes(
      this.modal.target,
    )
  }

  get isSla() {
    return ['DELETE', 'EDIT_SLA', 'REGISTER_SLA'].includes(this.modal.target)
  }

  get isEdit() {
    return ['EDIT_SLA', 'EDIT_SLA_CONFIG'].includes(this.modal.target)
  }

  get isDelete() {
    return this.modal.target === 'DELETE'
  }

  get slaTypeOptions() {
    return [
      { text: 'Hora útil', value: 'HoraUtil' },
      { text: 'Hora corrida', value: 'HoraCorrida' },
    ]
  }

  formState = {
    valid: true,
    tipo: [(v: any) => !!v || 'Campo obrigatório.'],
    horaInicio: [(v: any) => !!v || 'Campo obrigatório.'],
    horaFim: [(v: any) => !!v || 'Campo obrigatório.'],
    solicitacaoSituacao: [(v: any) => !!v || 'Campo obrigatório.'],
    quantidadeHorasCriterioNormal: [(v: any) => !!v || 'Campo obrigatório.'],
    quantidadeHorasCriterioAlerta: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  closeModal() {
    if (this.isSlaConfig) {
      this.getSuporteHospitalSlaStore.clearNewHospitalSlaConfig()
    } else {
      this.getSuporteHospitalSlaStore.clearNewHospitalSla()
    }
    this.modal = { isOpen: false, target: this.modal.target }
  }

  async save() {
    const isValid = (
      this.$refs.formRef as Vue & { validate: () => boolean }
    ).validate()
    if (isValid) {
      this.saveLoading = true
      try {
        if (this.isDelete) {
          await this.getSuporteHospitalSlaStore.deleteHospitalSla()
        } else if (this.isSlaConfig) {
          await this.getSuporteHospitalSlaStore.upsertHospitalSlaConfig()
        } else if (this.isSla) {
          await this.getSuporteHospitalSlaStore.upsertHospitalSla()
        }
      } finally {
        this.saveLoading = false
        this.closeModal()
      }
    }
  }
}
